<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<el-collapse class="request-info-approver cbs-collapse" :value="$attrs.disabled ? '' : '1'">
		<el-collapse-item name="1" v-bind="$attrs" :class="{ 'opacity-50': !!$attrs.disabled }">
			<template slot="title">
				<h6 class="uppercase font-bold ml-6 text-black">{{ title }}</h6>
			</template>
			<div class="content request-info-approver__content m-6 mb-0">
				<div class="flex mb-1" v-if="requestPurpose">
					<label class="w-1/2 sm:w-1/4 text-gray-1 break-normal">{{ $t("Purpose") }}:</label>
					<div class="text-black w-1/2 sm:w-3/4">{{ requestPurpose }}</div>
				</div>

				<request-step-info class="content__approve-info my-6 mb-0" v-if="value.status && value.status !== 0" :value="requestStepInfo" />
				<dynamic-form-content
					mode="single"
					:class="['content__request-form', { 'pb-6 border-0 border-b border-solid border-gray-5': value.status === 0 || isPendingInput }]"
					v-if="!isPendingInput && value.controls && value.controls.length"
					:value="value.controls"
					:mappedAttachObj="mappedAttachObj"
				/>

				<request-step-info class="content__approve-info my-6 mb-0" v-if="value.status === 0 || isPendingInput" :value="requestStepInfo" />
			</div>
		</el-collapse-item>
	</el-collapse>
</template>

<script>
import RequestStepInfo from "./RequestStepInfo";
import DynamicFormContent from "@/components/cbs-dynamic-form/DynamicFormContent";

export default {
	inheritAttrs: false,
	name: "RequestInfoApprover",
	components: {
		DynamicFormContent,
		RequestStepInfo
	},
	props: {
		value: {
			type: Object,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		requestPurpose: String,
		mappedAttachObj: Object,
		isPendingInput: Boolean
	},
	computed: {
		requestStepInfo() {
			let statusName;
			const approveData = [];
			const status = this.value.status || 0;
			const logsData = (this.value && this.value.logs) || {};

			if (status === this.$constant.REQUEST_STATUSES.APPROVED) {
				statusName = this.$t("Approved");
			}
			if (status === this.$constant.REQUEST_STATUSES.CANCELED) {
				statusName = this.$t("Canceled");
			}
			if (status === this.$constant.REQUEST_STATUSES.REJECTED) {
				statusName = this.$t("Rejected");
			}
			if (status === this.$constant.REQUEST_STATUSES.WAITING) {
				statusName = this.$t("Waiting");
			}
			approveData.push({
				note: logsData.note,
				updatedAt: logsData.updated_at,
				approverName: logsData.approved_by && logsData.approved_by.name
			});
			return {
				status,
				statusName,
				isPendingInput: this.isPendingInput,
				approveData: this.isPendingInput ? [] : approveData
			};
		}
	}
};
</script>

<style lang="scss" scoped>
.request-info-approver {
	::v-deep .el-collapse-item__content {
		padding-bottom: 0;
	}
}
</style>
